// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as TimeComponent} from './Time.svg';

import Icon, { TIconProps } from '../Icon';

export const IconTime = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <TimeComponent/>
  </Icon>
));
